import * as types from 'modules/hardwares/actionTypes';
import type { FetchHardwaresSuccessAction, ScrollPage } from 'modules/hardwares/types';
import { createReducer } from 'utils/ReduxUtils';

const initialState: ScrollPage = {
  size: 10,
  last: undefined,
};

const updateState = (state: ScrollPage, { payload }: FetchHardwaresSuccessAction): ScrollPage => ({
  ...state,
  last: payload.page.last,
});

const resetState = (): ScrollPage => initialState;

export default createReducer(initialState, {
  [types.FETCH_HARDWARES_SUCCESS]: updateState,
  [types.FETCH_HARDWARES_FAILURE]: resetState,
  [types.RESET_HARDWARES_DASHBOARD]: resetState,
  [types.SET_HARDWARES_DASHBOARD_FILTERS]: resetState,
  [types.SET_HARDWARES_DASHBOARD_FILTER]: resetState,
  [types.REMOVE_HARDWARES_DASHBOARD_FILTER]: resetState,
});
